import styled from 'styled-components';
import {
  COLOR_BLACK,
  COLOR_BLUE,
  COLOR_BLUE_005,
  COLOR_BLUE_050,
} from '@common/assets/styles/colors';

import PAGE_STYLES from 'helpers/page-styles';

export const ExpertRowSC = styled.div`
  height: 56px;

  padding-right: 8px;
  margin-bottom: 8px;

  display: flex;
  justify-content: space-between;

  cursor: pointer;

  &:hover,
  &:active,
  &.active {
    background-color: ${COLOR_BLUE_005};
    border-radius: 27px;
  }

  .left {
    display: flex;
    align-items: center;
    padding-left: 8px;

    & > div:first-child {
      width: 40px;
      height: 40px;
    }

    .text {
      margin-left: 16px;

      h5 {
        color: ${COLOR_BLACK};
        font-size: 17px;
        line-height: 25px;
        margin-bottom: 0;
      }

      span {
        font-size: 14px;
        line-height: 21px;
        color: ${COLOR_BLUE};
        margin-right: 5px;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
  }
`;

export default styled.div`
  ${PAGE_STYLES};

  h4 {
    color: ${COLOR_BLACK};
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 25px;
  }

  div.search-input {
    margin-bottom: 16px;
    width: 100%;

    input {
      color: ${COLOR_BLACK};

      &::placeholder {
        color: ${COLOR_BLUE_050};
      }
    }

    span > svg {
      width: 20px;

      path {
        fill: ${COLOR_BLACK};
      }

      > circle {
        stroke: ${COLOR_BLACK};
      }
    }
  }

  .experts-list {
    padding-right: 8px;
    overflow-y: auto;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ theme }) =>
      theme.responsive ? 'calc(100% - 320px)' : '240px'};

    > div {
      width: 30px;
      height: 30px;
    }
  }

  .no-experts {
    font-family: 'Mulish', sans-serif;
    padding-top: 40px;
    font-size: 17px;
    text-align: center;
    color: ${COLOR_BLACK};
    line-height: 27px;

    svg {
      display: block;
      margin: 24px auto;
    }
  }

  > .footer {
    max-height: 20px !important;
    height: 20px !important;
  }
`;
